<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 禁止页面缩放
    window.onload = function () {
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
  },
}
</script>
<style lang="less">
body {
  margin: 0;
  font-size: 12px;
  line-height: 1;
  font-family: "Helvetica Neue", Helvetica, STHeiTi, sans-serif; /*使用无衬线字体*/
  -webkit-text-size-adjust: 100% !important; /*禁止IOS调整字体大小*/
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  font-size: 100%;
  font-weight: normal;
}
ul,
ol {
  list-style: none;
  margin: 0;
  padding: 0;
}
p,
dl,
dd {
  margin: 0;
}
img {
  vertical-align: bottom;
  border: none;
}
a {
  text-decoration: none;
  color: #333;
}
strong,
b {
  font-weight: normal;
}
i,
em {
  font-style: normal;
}
table {
  border-spacing: 0;
  border-collapse: collapse;
}
th {
  font-weight: normal;
  text-align: left;
  vertical-align: top;
}
td {
  text-align: left;
  vertical-align: top;
}
input {
  margin: 0;
  padding: 0;
  border: none;
  font-family: inherit;
}
input,
textarea {
  outline: none;
}
textarea {
  resize: none;
  overflow: auto;
  font-family: inherit;
}
.clearfix:after {
  content: "";
  display: block;
  clear: both;
}
a,
button,
input,
select,
textarea {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  /*去掉a、input和button点击时的蓝色外边框和灰色半透明背景*/
}
img {
  vertical-align: bottom;
  border: none !important;
}

#app {
  height: 100%;
  font-family: PingFang SC-Regular, PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    .router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue